import dashboardStyles from '../../../Dashboard/Dashboard.style';
import { Divider, Menu, MenuItem, Typography, ListItemIcon, Box } from '@material-ui/core';
export const MenuItemsList = ({ optionsList, anchorEl, handleEvents, setAnchorEl }) => {
	const classes = dashboardStyles();

	return (
		<Menu
			id={`action-items`}
			anchorEl={anchorEl}
			transformOrigin={{
				vertical: -40,
				horizontal: 'center'
			}}
			className={classes.menu}
			elevation={1}
			MenuListProps={{
				'aria-labelledby': 'basic-button'
			}}
			open={!!anchorEl}
			onClose={() => {
				setAnchorEl(null);
			}}>
			{optionsList.map((item, idx) => {
				return (
					<Box key={`${item.name}-${idx}`}>
						<MenuItem
							id={`${item.name}-${idx}`}
							className={classes.menuItems}
							onClick={(e) => {
								handleEvents(item);
								e.stopPropagation();
								setAnchorEl(null);
							}}>
							{item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
							<Typography>{item.name}</Typography>
						</MenuItem>
						{item.divider && <Divider />}
					</Box>
				);
			})}
		</Menu>
	);
};
